import { render, staticRenderFns } from "./customOrder.vue?vue&type=template&id=50e50b16&scoped=true"
import script from "./customOrder.vue?vue&type=script&lang=js"
export * from "./customOrder.vue?vue&type=script&lang=js"
import style0 from "./customOrder.vue?vue&type=style&index=0&id=50e50b16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e50b16",
  null
  
)

export default component.exports